import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

import { OperationActionConfig, OperationFilterOption, OperationRecord } from "../types";

interface OperationActionDialogProps {
  open: boolean;
  record: OperationRecord | null;
  action: OperationActionConfig | null;
  actors: OperationFilterOption[];
  loading: boolean;
  onClose: () => void;
  onConfirm: (remarks: string, actorId: string) => void;
}

const OperationActionDialog = ({
  open,
  record,
  action,
  actors,
  loading,
  onClose,
  onConfirm,
}: OperationActionDialogProps) => {
  const [remarks, setRemarks] = useState("");
  const [actorId, setActorId] = useState("");

  useEffect(() => {
    if (open && !actorId && actors.length) {
      setActorId(actors[0].id);
    }
  }, [actorId, actors, open]);

  const handleClose = () => {
    setRemarks("");
    setActorId("");
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(remarks, actorId);
    setRemarks("");
    setActorId("");
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{action?.label || "Update Operation"}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <Typography color="text.secondary">
            {record?.module} • {record?.code}
          </Typography>
          <FormControl fullWidth>
            <InputLabel>Action By</InputLabel>
            <Select
              label="Action By"
              value={actorId}
              onChange={(event) => setActorId(event.target.value)}
            >
              {actors.map((actor) => (
                <MenuItem value={actor.id} key={actor.id}>
                  {actor.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Remarks"
            multiline
            minRows={3}
            value={remarks}
            onChange={(event) => setRemarks(event.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button
          variant="contained"
          disabled={loading || !action || !actorId}
          onClick={handleConfirm}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OperationActionDialog;
